import type { Channel, Conversation } from '@conversia/shared-types';
import { api } from './client';

/** Modo entrenamiento (ADMIN salvo los toggles de conversación). /api/training */

export interface TrainingExample {
  id: string;
  conversationId: string | null;
  channelId: string | null;
  agentId: string | null;
  question: string;
  answer: string;
  status: 'NUEVO' | 'DESCARTADO' | 'ANALIZADO';
  trainedByName: string | null;
  capturedAt: string;
  channel?: { name: string } | null;
  agent?: { name: string } | null;
}

export interface TrainingProposal {
  id: string;
  agentId: string | null;
  tipo: string;
  titulo: string;
  contenido: string;
  estado: 'PENDIENTE' | 'APROBADA' | 'RECHAZADA' | 'APLICADA' | 'REVERTIDA';
  createdAt: string;
  decidedAt: string | null;
  appliedAt: string | null;
  agent?: { name: string } | null;
}

export interface AgentLearning {
  id: string;
  agentId: string;
  proposalId: string | null;
  contenido: string;
  activo: boolean;
  appliedAt: string;
  appliedByName: string | null;
  revertedAt: string | null;
  agent?: { name: string } | null;
}

export interface TrainingSummary {
  nuevos: number;
  pendientes: number;
  aplicados: number;
  vpsConfigurado: boolean;
}

export const startConversationTraining = (id: string) =>
  api.post<Conversation>(`/api/training/conversations/${id}/start`);
export const stopConversationTraining = (id: string) =>
  api.post<Conversation>(`/api/training/conversations/${id}/stop`);
export const setChannelTraining = (id: string, trainingMode: boolean) =>
  api.patch<Channel>(`/api/training/channels/${id}`, { trainingMode });

export const getSummary = () => api.get<TrainingSummary>('/api/training/summary');

export const listExamples = (filters: { channelId?: string; status?: string } = {}) => {
  const params = new URLSearchParams();
  if (filters.channelId) params.set('channelId', filters.channelId);
  if (filters.status) params.set('status', filters.status);
  const qs = params.toString();
  return api.get<TrainingExample[]>(`/api/training/examples${qs ? `?${qs}` : ''}`);
};

export const updateExample = (
  id: string,
  data: { question?: string; answer?: string; descartar?: boolean },
) => api.patch<TrainingExample>(`/api/training/examples/${id}`, data);

export const analyze = () =>
  api.post<{ analizados: number; propuestas: number }>('/api/training/analyze');

export const listProposals = (estado?: string) =>
  api.get<TrainingProposal[]>(`/api/training/proposals${estado ? `?estado=${estado}` : ''}`);

export const decideProposal = (
  id: string,
  data: {
    accion: 'aprobar' | 'rechazar';
    titulo?: string;
    contenido?: string;
    agentId?: string | null;
  },
) => api.patch<TrainingProposal>(`/api/training/proposals/${id}`, data);

export const applyProposal = (id: string) =>
  api.post<AgentLearning>(`/api/training/proposals/${id}/apply`);

export const listLearnings = () => api.get<AgentLearning[]>('/api/training/learnings');

export const revertLearning = (id: string) =>
  api.post<AgentLearning>(`/api/training/learnings/${id}/revert`);
